import React, { useState } from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import useApi from '../../../hooks/useApi';
import useSnackbar from '../../../hooks/useSnackbar';
import { Stack } from '@mui/material';

const Domain = ({ account, onRefresh }) => {
    const [domainPrefix] = useState(account.sendingDomain?.split('.')[0] ?? 'bounced');
    const [domain, setDomain] = useState(account.sendingDomain?.split('.').slice(1).join('.') ?? '');
    const [subDomain, setSubDomain] = useState(account.sendingDomain ?? '');
    const { handlePut } = useApi();
    const { showSnackbar } = useSnackbar();
    const [spfFlattenedCheck, setSpfFlattenedCheck] = useState(account.spfFlattenedCheck ?? false);

    const handleChange = (newDomain) => {
        setDomain(newDomain);
        setSubDomain(`${domainPrefix}.${newDomain}`);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await handlePut(`account/${account.id}/sending-domain`, {
            domain: domain,
            sendingDomain: `${domainPrefix}.${domain}`,
            spfFlattenedCheck
        });

        if (!response.ok) {
            showSnackbar('An error occurred.', 'error');
            return;
        }

        showSnackbar('Details saved', 'success');
        onRefresh();
    };

    return (
        <>
            <Toolbar
                variant="dense"
                disableGutters
                sx={{ px: 2 }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2">
                        Sending Domain
                    </Typography>
                </Box>
            </Toolbar>
            <Divider />
            <form onSubmit={handleSubmit}>
                <Grid
                    container
                    spacing={4}
                    wrap="nowrap"
                    sx={{
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 2
                    }}
                >
                    <Grid>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="subtitle2">Sending Domain</Typography>
                            <TextField
                                size="small"
                                value={domain}
                                onChange={(e) => handleChange(e.target.value)}
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <IconButton onClick={handleSubmit} edge="end">
                                                <SearchIcon />
                                            </IconButton>
                                        )
                                    }
                                }}
                            />
                        </Stack>
                    </Grid>

                    <Grid>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="subtitle2">Sending Sub-Domain</Typography>
                            <Typography variant="body2">{subDomain || '—'}</Typography>
                        </Stack>
                    </Grid>

                    <Grid>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="subtitle2">SPF Flattened Check</Typography>
                            <Checkbox
                                checked={spfFlattenedCheck}
                                onChange={(e) => setSpfFlattenedCheck(e.target.checked)}
                            />
                        </Stack>
                    </Grid>

                    <Grid>
                        <Button type="submit" variant="contained">Submit</Button>
                    </Grid>
                </Grid>
            </form>
        </>
    );
};

export default Domain;